<template>
    <b-table
        class="data-table contagem"
        :data="itensPedido"
        @sort="$emit('sortTable')"
        backend-sorting
        striped
    >
        <b-table-column
            v-for="(f, i) in itemFields"
            :key="i"
            :field="f.key"
            :class="{
                'label-km': f.key == 'status_pedido_retorno',
            }"
            :label="f.label ? $t(f.label) : ''"
            :width="f.width"
            :sortable="f.sortable"
            :custom-sort="f.sortFn"
            :numeric="f.numeric"
        >
            <template v-slot:header>
                <span v-if="f.key == 'idprodutoerp'">
                    {{ $t("id-produto-erp") }}
                </span>
                <span v-else-if="f.key == 'produto'">
                    {{ $t("produto") }}
                </span>
                <span v-else-if="f.key == 'peso'">
                    {{ $t("pesoxqtde") }}
                    <div class="table-sep" />
                    {{ $t("pesoxqtdefaturado") }}
                </span>
                <span v-else-if="f.key == 'qtde'">
                    {{ $t("qntde") }}
                    <div class="table-sep" />
                    {{ $t("quantidade-faturada") }}
                </span>
                <span v-else-if="f.key == 'valorunitario'">
                    {{ $t("valor-venda") }}
                </span>
                <span v-else-if="f.key == 'valortotal'">
                    {{ $t("valor-total") }}
                </span>
                <span v-else-if="f.key == 'valorunfat'">
                    {{ $t("valor-faturado") }}
                </span>
                <span v-else-if="f.key == 'valortotalfat'">
                    {{ $t("valor-total-fat") }}
                </span>
                <b-icon 
                    class="m-0"
                    v-if="
                        f.key == 'valorunitario' ||
                        f.key == 'valorunfat' ||
                        f.key == 'valortotal' ||    
                        f.key == 'valortotalfat'
                    "
                    icon="information" 
                    size="is-small"
                    v-tippy 
                    :title="$t(`informacao-tooltip-valor-unitario`)"
                />
            </template>
            <template v-slot="props">
                <div v-if="f.key == 'valorunitario'" :title="props.row[f.key]">
                    {{ getDecimal(props.row[f.key], null, true) }}
                </div>
                <div v-else-if="f.key == 'valortotal'" :title="props.row[f.key]">
                    {{ getDecimal(props.row[f.key], null, true) }}
                </div>
                <div v-else-if="f.key == 'valortotalfat' || f.key == 'valorunfat'">
                    <div v-if="props.row.valorunitario != props.row.valorunfat">
                        <div class="laranja">
                            <b>
                                {{ getDecimal(props.row[f.key], null, true) }}
                            </b>
                        </div>
                    </div>
                    <div v-else>
                        <b>
                            {{ getDecimal(props.row[f.key], null, true) }}
                        </b>
                    </div>
                </div>
                <div v-else-if="f.key == 'qtde'">
                    {{ getDecimal(props.row.qtde) }}
                    <div class="table-sep" />
                    <div v-if="props.row.qtde != props.row.qtdefaturado">
                        <div class="laranja">
                            <b>
                                {{ getDecimal(props.row.qtdefaturado) }}
                            </b>
                        </div>
                    </div>
                    <div v-else>
                        <b>
                            {{ getDecimal(props.row.qtdefaturado) }}
                        </b>
                    </div>
                </div>
                <!-- @84266 - Adicionados campos de totais na listagem -->
                <div v-else-if="f.key == 'peso'">
                    {{ getDecimal(props.row.pesoxqtd) }}
                    <div class="table-sep" />
                    <div v-if="props.row.pesoxqtd != props.row.pesoxqtdfat">
                        <b class="laranja">{{getDecimal(props.row.pesoxqtdfat)}}</b>
                    </div>
                    <div v-else>
                        <b>{{ getDecimal(props.row.pesoxqtdfat) }}</b>
                    </div>
                </div>
                <div v-else-if="f.key == 'iditempedido'">
                    <div v-if="props.row[f.key] == '0'">
                        {{ props.row.idproduto }}
                    </div>
                    <div v-else>
                        {{ props.row.iditempedido }}
                    </div>
                </div>
                <div v-else-if="f.key == 'status_pedido_retorno'">
                    <div v-if="props.row[f.key] == 'ITEM_REMOVIDO'">
                        <div 
                            class="bar rem-ped" 
                            v-tippy 
                            :title="$t('item-removido')"
                        />
                    </div>
                    <div v-else-if="props.row[f.key] == 'ITEM_ADICIONADO'">
                        <div 
                            class="bar add-ped" 
                            v-tippy 
                            :title="$t('item-adicionado')"
                        />
                    </div>
                </div>
                <div v-else-if="f.key == 'detalhe'">
                    <b-tooltip
                        type="is-dark"
                        :label="$t('detalhe-item-pedido')"
                        position="is-right"
                        class="mr-2"
                    >
                        <span class="clickable icon-position" @click="carregarItensPedidoDetalhe(
                            props.row.iditempedido,
                            props.row.iditempedidosovis
                        )">
                            <b-icon icon="playlist-check" type="is-primary" />
                        </span>
                    </b-tooltip>
                </div>
                <div v-else>
                    {{ props.row[f.key] }}
                </div>
            </template>
        </b-table-column>
    </b-table>
</template>

<script>
export default {
    props: {
        itensPedido: Array,
    },
    data() {
        return {
            itemFields: [
                {
                    key: "detalhe",
                    width: 6,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "status_pedido_retorno",
                    width: 6,
                    sortable: false,
                    sortFn: null,
                },
                {
                    key: "idprodutoerp",
                    label: "id-produto-erp",
                    width: null,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "produto",
                    label: "produto",
                    width: null,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "tipopedido",
                    label: "tipo-pedido",
                    width: null,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "qtde",
                    label: "qntde",
                    width: null,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "peso",
                    label: "pesoxqtde",
                    width: null,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valorunitario",
                    label: "valor-venda",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valorunfat",
                    label: "valor-faturado",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valortotal",
                    label: "valor-total",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valortotalfat",
                    label: "valor-total-fat",
                    width: 200,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
            ],
        };
    },
    methods: {
        carregarItensPedidoDetalhe(idItemPedidoRetorno, idItemPedidoSovis) {
            this.$emit('idItemPedido', idItemPedidoRetorno);
            this.$emit('idItemPedidoSovis', idItemPedidoSovis);
        },
    },
};
</script>

<style lang="scss" scoped>
.laranja {
    color: #e68b15;
}

.verde {
    color: rgb(16, 153, 16);
}

.label-km {
    padding-left: 0;
    padding-right: 0;
}

.bar {
    border-radius: 100px;
    width: 6px;
    height: 27px;
    display: flex;

    &.add-ped {
        background-color: #5f971e;
    }

    &.rem-ped {
        background-color: #a82929;
    }
}

.bar-column {
    padding-left: 0.01rem;
    padding-right: 0.01rem;
}

@media (max-width: 760px) {
    .label-km {
        padding-left: 5px;
        padding-right: 20px;
        justify-content: left;
    }
}

.data-table {
    padding: 0 12px;
}

.icon-position {
    padding: 0px;
}
</style>